// Adding classs on the body dark and light mode toggle on the header

let themToggleBtn = document.querySelectorAll('.light-dark-toggle input[type=checkbox]');
const savedTheme = localStorage.getItem('theme');
    if(savedTheme == 'light')
    {
        document.body.classList.add('light-mode');
         themToggleBtn.forEach((el)=>{
             el.checked = true;
         });
    }

    themToggleBtn.forEach((el)=>{

    
    el.addEventListener('click',((btn)=>{
          if(el.checked)

        {
            document.body.classList.add('light-mode');
             localStorage.setItem('theme', 'light');

        }
        else{
            document.body.classList.remove('light-mode');
              localStorage.setItem('theme', 'dark');
        }
    
}));
    });



// cstm faq accordian js
let faqQuestioncontainer = document.querySelectorAll('section.cstm-faq-section .faq-item');

faqQuestioncontainer.forEach((el)=>{
    el.addEventListener('click',(()=>{
         if(el.classList.contains('active'))
        {
        let faqAnswer = el.querySelector('.faq-answer');

            el.classList.remove('active');
            faqAnswer.style.maxHeight = '0px';
        }
        else{
        let faqAnswer = el.querySelector('.faq-answer');
    
                faqQuestioncontainer.forEach(item => {
                    let faqAnswer = item.querySelector('.faq-answer');

                    faqAnswer.style.maxHeight = '0px';
                    item.classList.remove('active');
                });
       
            el.classList.add('active');
            faqAnswer.style.maxHeight = (faqAnswer.scrollHeight + 46) + "px";
        }
    }))
});


// Trusted by industry leader section js
//checking if the section is in the view port
const trustedBySection = document.querySelector('.digital-dominance-section');
let digitalDominanceNumbers = document.querySelectorAll('.digital-dominance-section .stat-value');
//checking if the element is in the view port
const trustedBySectionobserver = new IntersectionObserver((entries,obs) => {
     entries.forEach(entry => {
         if (entry.isIntersecting) {
              digitalDominanceNumbers.forEach((el)=>{

                let orignalNumber = el.textContent.trim();
                // console.log(orignalNumber);

                const getNumber = (val) => {
                const num = parseFloat(val);
                    if (val.includes('B')) return num * 1e9;
                    if (val.includes('M')) return num * 1e6;
                    if (val.includes('K')) return num * 1e3;
                    return num;
                };
                const formatNumber = (num, original) => {
                    if (original.includes('B')) return (num / 1e9).toFixed(1) + 'B';
                    if (original.includes('M')) return (num / 1e6).toFixed(1) + 'M';
                    if (original.includes('K')) return (num / 1e3).toFixed(1) + 'K';
                    return Math.floor(num);
                };
                const target = getNumber(orignalNumber);
                let initialVal = 0;
                const increment = target / 100; // speed control
                const updateCounter = () => {
                    initialVal += increment;
                    if (initialVal < target-1000) 
                    {
                        el.textContent = formatNumber(initialVal, orignalNumber);
                        requestAnimationFrame(updateCounter);
                    } 
                    else 
                    {
                    el.textContent = orignalNumber; // final exact value (25B, 8.5M)
                    }
                };
                updateCounter();
            });
              obs.disconnect();
         }
    });
},
{
     threshold: 0.8 // 40% section visible hone par trigger hoga
});
if(trustedBySection)
{

    trustedBySectionobserver.observe(trustedBySection);
}


//Time line section js

const timelineTextContent = document.querySelectorAll('.timeline-section .timeline-item');
const timelineImageContent = document.querySelectorAll('.timeline-section .timeline-wrapper .image-block-cotainer .timeline-image');
const progressBarYears = document.querySelectorAll('.timeline-section .year-wrap .bar-year');
let backgroundYear = document.querySelector('.timeline-section .background-year');
let yearsValue = document.querySelectorAll('.timeline-section .timeline-item .timeline-year');
timelineTextContent.forEach(element => {
    timelineImageContent[0].classList.add('active'); 
    const timelineTextContentobserver = new IntersectionObserver((entries,obs) => {
        timelineSectionProgressBar();
         entries.forEach(entry => {
            if (entry.isIntersecting) {
                
                const index = [...element.parentNode.children].indexOf(element);

                timelineImageContent.forEach(el => el.classList.remove('active'));

                timelineImageContent[index].style.position = 'fixed'; 

                timelineImageContent[timelineImageContent.length - 1].style.position = 'sticky'; 

                timelineImageContent[index].classList.add('active'); 
               
                backgroundYear.textContent = yearsValue[index].textContent;
                }
             });
             },
    {
        threshold: 0.9 // 40% section visible hone par trigger hoga
    });
    if(element)
{

    timelineTextContentobserver.observe(element);
    
}
}); 



//Function of the js for the timeline section progress bar animation

function timelineSectionProgressBar() {
    const timeLneSectionContainer = document.querySelector('.timeline-section');
    const timeliseProgressBar = document.querySelector('.timeline-section .timeline-bar-contiainer .progress-bar');
    const totalProgressYearLength = progressBarYears.length;
    let progressYearDivideValue = 100 / totalProgressYearLength;

    window.addEventListener('scroll', () => {
    const rect = timeLneSectionContainer.getBoundingClientRect();
    const sectionTop = rect.top;
    const sectionHeight = timeLneSectionContainer.offsetHeight;
    const viewportHeight = window.innerHeight;
     
    // total scrollable distance
    const totalScroll = sectionHeight - viewportHeight;

    // kitna scroll ho chuka hai
    let scrolled = Math.abs(sectionTop);

    // percentage calculate
    let progress = scrolled / totalScroll;

    progress = Math.max(0, Math.min(1, progress));

    const percentage = progress * 100;
    timeliseProgressBar.style.width = `${percentage.toFixed(2)}%`;

    //Making the first image sticky again
    if( timeliseProgressBar.style.width <= '10%')
    {
          timelineImageContent[0].style.position = 'sticky';
    }
    progressBarYears.forEach((el, index) => {
  
            if (percentage >= progressYearDivideValue * (index + 0.5)) {
                el.classList.add('active');
            } else {
                el.classList.remove('active');
            }

        });

    });

   
   
    //years color changes based on width
    
   
}


// cursor js 
 // CURSOR
  const cursor = document.getElementById('cursor');
  const ring = document.getElementById('cursorRing');
  let mx = 0, my = 0, rx = 0, ry = 0;

  document.addEventListener('mousemove', e => {
    mx = e.clientX; my = e.clientY;
    cursor.style.left = mx - 4 + 'px';
    cursor.style.top  = my - 4 + 'px';
  });

  function animRing() {
    rx += (mx - rx) * 0.12;
    ry += (my - ry) * 0.12;
    ring.style.left = rx + 'px';
    ring.style.top  = ry + 'px';
    requestAnimationFrame(animRing);
  }
  animRing();



// services page success secttion counter 
function servicesSuccessCounter()
{
gsap.registerPlugin(ScrollTrigger);

const items = document.querySelectorAll(".services-success-section__number");

ScrollTrigger.create({
  trigger: ".services-success-section", // 👈 section trigger
  start: "top 80%",
  once: true, // sirf ek baar chalega

  onEnter: () => {
    items.forEach(item => {

      let target = parseInt(item.getAttribute("data-count"));

      gsap.fromTo(item, 
        { textContent: 0 }, 
        {
          textContent: target,
          duration: 2,
          ease: "power1.out",
          snap: { textContent: 1 },

          onUpdate: function () {
            item.innerHTML = numberWithCommas(Math.floor(item.textContent)) + "%";
          }
        }
      );

    });
  }
});

function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
}
  if (window.gsap && window.ScrollTrigger) servicesSuccessCounter();





// services section tabbing gsap 
function servicesSecTabingGsap(){

    
    const easeSlow = CustomEase.create("easeSlow", "0.4, 0, 0, 1");
    
    const parents = document.querySelectorAll(".services-max-sec .c-vertical-tabs");
    
    parents.forEach((parent) => {
        const tabList = parent.querySelector(".c-vertical-tabs__tablist");
        const tabButtons = parent.querySelectorAll(".c-vertical-tabs__tablist button");
        const images = parent.querySelectorAll(".c-vertical-tabs__images figure");
  const contents = parent.querySelectorAll(".c-vertical-tabs__content div");
  
  let currentImage = images[0];
  let currentContent = contents[0];
  
  const highlightButton = (clickedButton, index) => {
    const activeMarkerPercentage = 100 / tabButtons.length;
    
    tabButtons.forEach((button) => {
        button.setAttribute("aria-selected", "false");
    });
    clickedButton.setAttribute("aria-selected", "true");
    
    gsap.to(tabList, {
      "--active-marker-offset": `${activeMarkerPercentage * index}%`,
      duration: 1,
      ease: easeSlow
    });
};

const showImage = (clickedButton) => {
    const target = clickedButton.getAttribute("data-target");
    const targetImage = parent.querySelector(`.c-vertical-tabs__images [data-target="${target}"]`);
    const img = targetImage.querySelector("img");

    if (currentImage == targetImage) return;
    
    images.forEach((image) => {
      image.setAttribute("data-state", "default");
    });
    
    currentImage.setAttribute("data-state", "previous");
    targetImage.setAttribute("data-state", "current");
    currentImage = targetImage;
    
    gsap.from(img, {
        scale: 1,
        duration: 1.5,
        ease: easeSlow
    });
    
    gsap.fromTo(
        targetImage, {
            clipPath: "polygon(0% 100%, 100% 100%, 100% 100%, 0% 100%)"
        }, {
        clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
        duration: 1.5,
        ease: easeSlow
    }
);
};

const showContent = (clickedButton) => {
    const target = clickedButton.getAttribute("data-target");
    const targetContent = parent.querySelector(`.c-vertical-tabs__content [data-target="${target}"]`);
    const targetHeading = targetContent.querySelector("h2");
    const targetText = targetContent.querySelector("p");
    const tl = gsap.timeline();
    
    if (currentContent == targetContent) return;
    
    tl
    .to(currentContent, {
        autoAlpha: 0,
        duration: 0.15,
        onComplete: () => {
            gsap.set(currentContent, {
                display: "none"
        });
        currentContent = targetContent;
    }
})
    .set(targetContent, {
        display: "block",
      autoAlpha: 1
    })
    .from([targetHeading, targetText], {
        autoAlpha: 0,
        y: 50,
        duration: 1.5,
        stagger: 0.1,
        ease: "power4.out"
    });
  };
  
  tabButtons.forEach((button, index) => {
      button.addEventListener("click", () => {
          highlightButton(button, index);
          showImage(button);
          showContent(button);
        });
    });
});

}
  if (window.gsap && window.CustomEase) servicesSecTabingGsap();




//buyer guide page card read more functionality
function buyerGuideCardReadMore()
{

    let buterGuideCardContainer = document.querySelector('section.buyer-guide-card .newsletter-right');
    let ReadMoreBtn = document.querySelector('section.buyer-guide-card .newsletter-wrapper #loadMoreBtn');
    let visible = 6;
    ReadMoreBtn.addEventListener('click',((el)=>{
             let hiddenCards = buterGuideCardContainer.querySelectorAll('.hidden-card');
                for (let i = 0; i < 6; i++) {
                    if (hiddenCards[i]) {
                    hiddenCards[i].classList.remove('hidden-card');
                    }
                }
        if (buterGuideCardContainer.querySelectorAll('.hidden-card').length === 0) {
            ReadMoreBtn.style.display = 'none';
        }
    }));
    // agar aur hidden cards nahi bache to button hide kar do
   
    // console.log(buterGuideCardContainer);

}

buyerGuideCardReadMore();